import type { StorefrontFeatureKey } from "@loot-os/api-contract";
import type { ReactNode } from "react";

import { useTenant } from "../lib/tenant.js";
import { NotFound } from "./NotFound.js";

/** Renders a 404 when the tenant has the given feature disabled. */
export function FeatureGate({
  feature,
  children,
}: {
  feature: StorefrontFeatureKey;
  children: ReactNode;
}) {
  const { hasFeature } = useTenant();
  if (!hasFeature(feature)) return <NotFound />;
  return <>{children}</>;
}
